import { render, staticRenderFns } from "./StatisticCards.vue?vue&type=template&id=6b236c8a&scoped=true&"
import script from "./StatisticCards.vue?vue&type=script&lang=js&"
export * from "./StatisticCards.vue?vue&type=script&lang=js&"
import style0 from "./StatisticCards.vue?vue&type=style&index=0&id=6b236c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b236c8a",
  null
  
)

export default component.exports